import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', () => {

  const mobile = () => {
    const methods = document.querySelectorAll(".js-method");
    const photos = document.querySelectorAll('.js-methods-photo');

    let mediaQuery = '(max-width: 768px)',
      mediaQueryList = window.matchMedia(mediaQuery);

    let observer;

    const start = () => {
      const options = {
        root: null,
        threshold: 0.5
      };

      let activeIndex = -1;

      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const newIndex = Array.from(methods).indexOf(entry.target);

            if (newIndex !== activeIndex) {
              if (activeIndex >= 0) {
                photos[activeIndex].classList.remove('is-active');
              }
              photos[newIndex].classList.add('is-active');
              activeIndex = newIndex;
            }
          }
        });
      }, options);

      methods.forEach(card => observer.observe(card));
    };

    mediaQueryList.addEventListener('change', event => {
      if (event.matches) {
        start();
      } else if (observer) {
        methods.forEach(card => observer.unobserve(card));
      }
    });

    if (mediaQueryList.matches) {
      start();
    }
  };

  const desktop = () => {
    let mediaQuery = '(min-width: 769px)',
      mediaQueryList = window.matchMedia(mediaQuery),
      animations = [];

    let isActive = false;
    const body = document.querySelector("body");

    const start = () => {
      if (isActive) return;
      isActive = true;

      animations.push(

        gsap.to('.js-methods #methods-grid', {
          scrollTrigger: {
            pin: '.js-methods #methods-grid',
            end: '+=2250s',
            pinSpacing: true,
          },
        }),

        gsap.to('#method_01', {
          scrollTrigger: {
            trigger: '#method_01',
            toggleActions: 'play reverse play complete',
            start: '0s',
            end: '+=500s',
            onEnter: () => body.classList.remove('bg-violet'),
            onEnterBack: () => body.classList.remove('bg-violet'),
          },
          opacity: 1,
        }),

        gsap.fromTo(
          '#method_02',
          {
            opacity: 0,
            y: 50
          },
          {
            opacity: 1,
            y: 0,
            scrollTrigger: {
              trigger: '#method_02',
              toggleActions: 'play reverse play reverse',
              start: '+=500s',
              end: '+=500s',
              onEnter: () => body.classList.add('bg-violet'),
              onEnterBack: () => body.classList.add('bg-violet')
            },
          }
        ),

        gsap.fromTo(
          '#method_03',
          {
            opacity: 0,
            y: 50
          },
          {
            opacity: 1,
            y: 0,
            scrollTrigger: {
              trigger: '#method_03',
              toggleActions: 'play reverse play reverse',
              start: '+=1000s',
              end: '+=500s',
              onEnter: () => body.classList.remove('bg-violet'),
              onEnterBack: () => body.classList.remove('bg-violet')
            },
          }
        ),

        gsap.fromTo(
          '#method_04',
          {
            opacity: 0,
            y: 50
          },
          {
            opacity: 1,
            y: 0,
            scrollTrigger: {
              trigger: '#method_04',
              toggleActions: 'play none reverse reverse',
              start: '+=1500s',
              end: '+=500s',
              onEnter: () => body.classList.add('bg-violet'),
              onEnterBack: () => body.classList.remove('bg-violet')
            },
          }
        )

      );
    };

    const resetAnimations = () => {
      animations.forEach(animation => {
        if (!animation) return;

        if (animation.scrollTrigger) {
          animation.scrollTrigger.kill();
        }

        animation.kill();
      });

      animations = [];
      isActive = false;

      gsap.set(
        [
          '.js-methods #methods-grid',
          '#method_01',
          '#method_02',
          '#method_03',
          '#method_04'
        ],
        { clearProps: 'all' }
      );

      ScrollTrigger.refresh();
    };

    mediaQueryList.addEventListener('change', event => {
      if (event.matches) {
        start();
      } else {
        resetAnimations();
      }
    });

    if (mediaQueryList.matches) {
      start();
    }
  };

  if (document.querySelector('.js-methods')) {
    mobile();
    desktop();
  }

}, false);